import React, { useState, useEffect, useRef } from 'react';
import pic from '../assets/images/pic2.jpg';

const Calculator = () => {
  const [price, setPrice] = useState("150000");
  const [downPaymentPercentage, setDownPaymentPercentage] = useState("5");
  const [loanTerm, setLoanTerm] = useState("25");
  const [interestRate, setInterestRate] = useState("6.5");
  const widgetRef = useRef(null);

  const downPayment = (Number(price) * Number(downPaymentPercentage)) / 100;
  const loanAmount = Number(price) - downPayment;
  const monthlyInterestRate = (Number(interestRate) / 100) / 12;
  const numberOfPayments = Number(loanTerm) * 12;

  const monthlyPayment = loanAmount > 0 && monthlyInterestRate > 0 && numberOfPayments > 0
    ? (loanAmount * monthlyInterestRate) / (1 - Math.pow(1 + monthlyInterestRate, -numberOfPayments))
    : 0;

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cloudcma.com/api_widget/050a44cb4080a9aa58438dea67ddd305/new?format=js';
    script.id = 'cloudcma_api_widget_script';
    script.async = true;
    if (widgetRef.current) {
      widgetRef.current.innerHTML = ''; // clear any existing script/widgets
      widgetRef.current.appendChild(script);
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-6">
      {/* Calculator Card */}
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-4xl w-full flex flex-col md:flex-row gap-6">
        {/* Image Box */}
        <div className="w-full md:w-1/2 flex items-center justify-center">
          <img src={pic} alt="Mortgage" className="w-full h-auto rounded-lg shadow" />
        </div>

        {/* Calculator Box */}
        <div className="w-full md:w-1/2 p-4 bg-gray-50 rounded-lg shadow">
          <h2 className="text-2xl font-bold text-gray-800 text-center">Mortgage Calculator</h2>
          <p className="text-gray-600 text-center mb-4">Calculate your estimated monthly mortgage payment.</p>

          <div className="space-y-4">
            <div>
              <label className="block text-gray-700">Property Price ($)</label>
              <input 
                type="number" 
                value={price} 
                onChange={(e) => setPrice(e.target.value)} 
                className="w-full p-2 border rounded" 
              />
            </div>

            <div>
              <label className="block text-gray-700">Down Payment (%)</label>
              <input 
                type="number" 
                value={downPaymentPercentage} 
                onChange={(e) => setDownPaymentPercentage(e.target.value)} 
                className="w-full p-2 border rounded" 
              />
            </div>

            <div>
              <label className="block text-gray-700">Length of Mortgage (Years)</label>
              <input 
                type="number" 
                value={loanTerm} 
                onChange={(e) => setLoanTerm(e.target.value)} 
                className="w-full p-2 border rounded" 
              />
            </div>

            <div>
              <label className="block text-gray-700">Annual Interest Rate (%)</label>
              <input 
                type="number" 
                value={interestRate} 
                onChange={(e) => setInterestRate(e.target.value)} 
                className="w-full p-2 border rounded" 
              />
            </div>
          </div>

          <div className="mt-6 text-center">
            <h3 className="text-lg font-semibold text-gray-800">Estimated Monthly Payment:</h3>
            <p className="text-2xl font-bold text-blue-600">
              ${monthlyPayment.toFixed(2)}
            </p>
          </div>
        </div>
      </div>

      {/* CloudCMA Script Injected Here */}
      <div
        ref={widgetRef}
        className="mt-8 w-full max-w-4xl text-center"
      />
    </div>
  );
};

export default Calculator;
